import React from "react";

import { SectionHeaderBlock as Value } from "@reactivated";

import { ButtonPrimary } from "../Clickables";
import { RichText } from "../RichText";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const SectionHeaderBlock = ({ value }: Props) => {
    if (!value.text) return <></>;

    return (
        <div className={styles.root}>
            <div className={styles.inner}>
                <RichText
                    value={value.text}
                    constrainParagraphWidth="two-thirds"
                />
                {(value.link?.url || value.link?.anchor) && (
                    <ButtonPrimary
                        simpleLink={value.link}
                        className={styles.clickable}
                    />
                )}
            </div>
        </div>
    );
};
